import "./App.css";
import AdminPanel from "./AdminPanel";
import "bootstrap/dist/css/bootstrap.css";
import "react-datetime-picker/dist/DateTimePicker.css";
import "react-calendar/dist/Calendar.css";
import "react-clock/dist/Clock.css";
import "react-toastify/dist/ReactToastify.css";
import { createWeb3Modal, defaultConfig } from "@web3modal/ethers/react";
import { network } from "./utils/contants.js";
import { Route, Routes } from "react-router-dom";
import { appKitProjectId } from "./utils/contants.js";
import Sidebar from "./components/SideBar/index.tsx";
import Header from "./components/Header/index.tsx";
import AdminAffiliatePage from "./pages/Affiliate/Affiliate.tsx";
import RevokedAffiliates from "./pages/RevokedAffilates.tsx";
import Sales from "./pages/Sales.tsx";

const metadata = {
  name: "My Website",
  description: "My Website description",
  url: "https://mywebsite.com", // origin must match your domain & subdomain
  icons: ["https://avatars.githubusercontent.com/u/37784886"],
};

createWeb3Modal({
  ethersConfig: defaultConfig({ metadata }),
  chains: [network],
  projectId: appKitProjectId,
  enableAnalytics: true, // Optional - defaults to your Cloud configuration
  themeMode: "light",
});
function App() {
  return (
    <div>
      <div style={{ display: "flex" }} className="app-wrapper">
        <Sidebar />
        <Header />
        <div
          style={{ marginLeft: "250px", padding: "20px", width: "100%" }}
          className="routes-wrapper"
        >
          <Routes>
            <Route path="/" element={<AdminPanel />} />
            <Route path="/affiliate" element={<AdminAffiliatePage />} />
            <Route path="/revoked-affiliate" element={<RevokedAffiliates />} />
            <Route path="/sales" element={<Sales />} />
            {/* <Route path="/reset-password" element={<ResetPassword />} /> */}
            {/* <Route path="/confirm-reset" element={<ConfirmResetPassword />} /> */}
          </Routes>
        </div>
      </div>
    </div>
  );
}

export default App;
